import { CommonModule } from "@angular/common";
import { Component, input } from "@angular/core";
import { RouterLink } from "@angular/router";
import { EvCore } from "ev-core";
import { IMiniInfocardCommercial } from "src/models/commercial/IMiniInfocardDataCommercial.model";
import { MiniInfoCardRealEstatePropertiesComponent } from "../components/mini-infocard-realestate-properties/mini-infocard-realestate-properties.component";

@Component({
    selector: "residential-sale-property-info",
    templateUrl: "./residential-sale-property-info.component.html",
    styleUrl: "./residential-sale-property-info.component.scss",
    imports: [EvCore, CommonModule, RouterLink, MiniInfoCardRealEstatePropertiesComponent],
})
export class ResidentialSalePropertyInfoComponent {
    selectedSale = input.required<IMiniInfocardCommercial>();
}
